import { useEffect, useRef } from "react";
import { useIsFetching } from "@tanstack/react-query";
import { pushGlobalLoading, popGlobalLoading } from "../utils/progress";

/**
 * Mirrors in-flight React Query requests onto the global progress depth counter.
 * HTTP calls also increment via axios interceptors, so concurrent fetches stack correctly.
 */
export function QueryFetchingProgress() {
  const fetchingCount = useIsFetching();
  const prev = useRef(0);

  useEffect(() => {
    const delta = fetchingCount - prev.current;
    prev.current = fetchingCount;
    if (delta > 0) {
      for (let i = 0; i < delta; i += 1) {
        pushGlobalLoading();
      }
    } else if (delta < 0) {
      for (let i = 0; i < -delta; i += 1) {
        popGlobalLoading();
      }
    }
  }, [fetchingCount]);

  return null;
}

export default QueryFetchingProgress;
